<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Analysez une annonce
                <span>Lancer une analyse à partir d'un lien</span>
            </h1>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-lg-12">
            <div class="p-0">
                <app-ad-tabs class="tools" [favorite]="favorite" [tabs]="tabs" [path]="'/app/tools/'"></app-ad-tabs>
                <app-ad-widgets [favorite]="favorite" (favoriteChange)="updateAd()" [tab]="tab"
                                [link]="'/app/tools/rendement'" [edit]="false" [custom]="false"></app-ad-widgets>
            </div>
        </div>
    </div>
</div>
